<template>
  <divcard titled>
    <div class="card-part pt-0">
      <div class="txt-head black--text mb-2">
        <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
      </div>

      <!-- Form 1 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('one')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            1. ผู้รับผิดชอบโครงการ (Project Manager) (ภาคเอกชน)
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชื่อผู้รับผิดชอบโครงการ
              </div>
              <div>{{ partTwoForm.s2_p1_pm_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ตำเเหน่ง
              </div>
              <div>{{ partTwoForm.s2_p1_pm_position }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                เบอร์โทรศัพท์
              </div>
              <div>{{ partTwoForm.s2_p1_pm_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                E-mail
              </div>
              <div>{{ partTwoForm.s2_p1_pm_email }}</div>
            </div>
          </div>

          <!--    Teams    -->
          <div
              v-if="
            partTwoForm.project_teams && partTwoForm.project_teams.length > 0
          "
              class="indent-info mb-3 black--text font-type-bold"
          >
            ข้อมูลประสานงานโครงการ
          </div>
          <div
              v-for="(team, i) in partTwoForm.project_teams"
              :key="i"
              class="indent-info d-flex flex-column gap-8 mb-3"
          >
            <div class="mb-1 black--text topic-field font-type-bold">
              1.{{ i + 1 }}
            </div>
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
                <div>{{ team.s2_p1_name }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">ตำเเหน่ง</div>
                <div>{{ team.s2_p1_position }}</div>
              </div>
            </div>

            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">เบอร์โทรศัพท์</div>
              <div>{{ team.s2_p1_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-mail</div>
              <div>{{ team.s2_p1_email }}</div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- Form 2 activity 1 2 -->
    <div class="card-part" v-if="activity && activity !== '3'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_act_scope ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            2. ขั้นตอนและขอบเขตการดำเนินกิจกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 4 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm?.s2_act_scope?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 2 activity 3 -->
    <div class="card-part" v-else>
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_principle ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            2. หลักการและเหตุผล
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 4 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_principle?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 3 activity 1 2 -->
    <div class="card-part" v-if="activity && activity !== '3'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_principle ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            3. หลักการและเหตุผล
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_principle?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 3 activity 3 -->
    <div class="card-part" v-else>
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_objective ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            3. วัตถุประสงค์
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_objective?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 4 activity 1 2 -->
    <div class="card-part" v-if="activity && activity !== '3'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_objective ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            4. วัตถุประสงค์
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_objective?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 4 activity 3 -->
    <div class="card-part" v-else>
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_target ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            4. เป้าหมาย
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_target?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 5 activity 1 -->
    <div class="card-part" v-if="activity && activity === '1'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_focus_industry ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            5. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_focus_industry?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 5 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_target ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            5. เป้าหมาย
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_target?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 5 activity 3 -->
    <div class="card-part" v-if="activity && activity === '3'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_past_work ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            5. ผลการดำเนินงานที่ผ่านมา
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_past_work?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 6 activity 1 -->
    <div class="card-part" v-if="activity && activity === '1'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_target ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            6. เป้าหมาย
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_target?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 6 activity 2 3 -->
    <div class="card-part" v-else>
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('sixAct23')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            6. แนวคิดและภาพรวมการจัดกิจกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 6 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนวคิดและรูปแบบการจัดกิจกรรม
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_act_concept?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 6 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมในการจัดงานของอุทยานวิทยาศาสตร์ (ประสบการณ์ในการดำเนินงานที่สอดคล้องกับกิจกรรมที่ผ่านมา ความเชี่ยวชาญในเนื้องาน )
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_ready?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 6 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การกำหนดคุณสมบัติของผู้เข้าร่วมแข่งขัน
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_qualify?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 6 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การกำหนดเกณฑ์ที่ใช้ในการตัดสินและคณะกรรมการในการตัดสิน
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_criteria?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 6 #line5 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนวทางการเชื่อมโยงผลักดันผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ (ที่สามารถเห็นผลได้ชัดเจนในอนาคต)
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_guideline?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Form 7 activity 1 -->
    <div class="card-part" v-if="activity && activity === '1'">
      <div v-if="!isFinal">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_past_work ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            7. ผลการดำเนินงานที่ผ่านมา
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_past_work?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_act_idea ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            7. แนวคิดและภาพรวมการจัดกิจกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_act_idea?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 7 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('sevenAct2')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            7. ขั้นตอนการดำเนินกิจกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_ads?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การคัดเลือกผู้เข้าร่วมโครงการและวิธีในการคัดเลือกสิ่งประดิษฐ์หรือนวัตกรรมที่มีศักยภาพในการต่อยอดสู่เชิงพาณิชย์
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_select?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การดำเนินการเตรียมความพร้อมให้กับผู้ที่เข้าร่วมโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_action?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line4 -->
          <div class="flex-center gap-16" v-if="!isFinal">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับมหาวิทยาลัย
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_act_uni?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line5 -->
          <div class="flex-center gap-16" v-if="!isFinal">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับภูมิภาค
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_act_region?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line6 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับประเทศ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_act_country?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line7 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดแนวทางการต่อยอดเพื่อพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_continue?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line8 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_p8_project_evaluate?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Form 7 activity 3 -->
    <div class="card-part" v-if="activity && activity === '3'">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_act_scope ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            7. ขั้นตอนและขอบเขตการดำเนินกิจกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_act_scope?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 8 activity 1 -->
    <div class="card-part" v-if="activity && activity === '1'">
      <div v-if="!isFinal">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_act_idea ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            8. แนวคิดและภาพรวมการจัดกิจกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_act_idea?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('eightAct1')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            8. ขั้นตอนการดำเนินงาน/กิจกรรมหลัก
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                วิธีหาลูกค้าที่มีศักยภาพ การเจาะกลุ่มเป้าหมาย และตัวอย่างผู้ประกอบการที่สนใจเข้าร่วมโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_finding?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กระบวนการและเกณฑ์การคัดเลือกผู้ประกอบการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_ent_select?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="mb-1 black--text">
              การบริหารจัดการและกระบวนการดำเนินงานของหน่วยบ่มเพาะ
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบ่มเพาะผู้ประกอบการรายเดิม
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_original_ent?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบ่มเพาะผู้ประกอบการรายใหม่
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_new_ent?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ศักยภาพ ความพร้อมในการให้บริการของศูนย์บ่มเพาะและอุทยานวิทยาศาสตร์ภูมิภาค
              </div>
              <div class="indent-info d-flex flex-column gap-8">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      บุคลากร พี่เลี้ยง
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_nanny?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      ผู้เชี่ยวชาญที่ช่วยสนับสนุนความรู้ในด้านต่างๆ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_expert?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      เครือข่ายทางธุรกิจเทคโนโลยีที่เกี่ยวข้อง
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_network?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      โครงสร้างพื้นฐาน พื้นที่ให้เช่า และสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_facility?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      บริการอื่นๆที่เกี่ยวข้อง เช่น ด้านการเงิน การบริหารจัดการทรัพย์สินทางปัญญา เป็นต้น
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_service?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรม เส้นทางสู่นวัตวณิชย์ Research to Market (R2M)
              </div>
              <div class="indent-info d-flex flex-column gap-8">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การดำเนินงาน
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_operation?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_main_ads?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การต่อยอดพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_main_continue?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_project_evaluate?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Form 8 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2'">
      <div v-if="!isFinal">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_rsp_procedure ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            8. ขั้นตอนการดำเนินกิจกรรม RSP New Release
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_rsp_procedure?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('eightAct2')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            8. ขั้นตอนการดำเนินงาน/กิจกรรมหลัก
          </div>
        </div>
        <div class="indent-info d-flex flex-column gap-8">
          <div class="mb-1 black--text">
            การจัดกิจกรรม RSP New Release
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การดำเนินงาน
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_operation?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_main_ads?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การต่อยอดพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_main_continue?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 8 activity 3 -->
    <div class="card-part" v-if="activity && activity === '3'">
      <!-- Activity 3 Form 8 [SI] -->
      <div v-if="!isFinal">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('eightAct3SI')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            8. ขั้นตอนการดำเนินงาน/กิจกรรมหลัก
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                วิธีหาลูกค้าที่มีศักยภาพ การเจาะกลุ่มเป้าหมาย และตัวอย่างผู้ประกอบการที่สนใจเข้าร่วมโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_finding?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กระบวนการและเกณฑ์การคัดเลือกผู้ประกอบการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_ent_select?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="mb-1 black--text">
              การบริหารจัดการและกระบวนการดำเนินงานของหน่วยบ่มเพาะ
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบ่มเพาะผู้ประกอบการรายเดิม
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_original_ent?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบ่มเพาะผู้ประกอบการรายใหม่
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_new_ent?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ศักยภาพ ความพร้อมในการให้บริการของศูนย์บ่มเพาะและอุทยานวิทยาศาสตร์ภูมิภาค
              </div>
              <div class="indent-info d-flex flex-column gap-8">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      บุคลากร พี่เลี้ยง
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_nanny?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      ผู้เชี่ยวชาญที่ช่วยสนับสนุนความรู้ในด้านต่างๆ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_expert?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      เครือข่ายทางธุรกิจเทคโนโลยีที่เกี่ยวข้อง
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_network?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      โครงสร้างพื้นฐาน พื้นที่ให้เช่า และสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_facility?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      บริการอื่นๆที่เกี่ยวข้อง เช่น ด้านการเงิน การบริหารจัดการทรัพย์สินทางปัญญา เป็นต้น
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_service?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_p9_project_evaluate?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>
      <!-- Activity 3 Form 8 [PF] -->
      <div v-else>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('eightAct3PF')">
          </ValidatorIcon>
          <div class="font-type-bold black--text">
            8. ขั้นตอนการดำเนินกิจกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_ads?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การคัดเลือกผู้เข้าร่วมโครงการและวิธีในการคัดเลือกสิ่งประดิษฐ์หรือนวัตกรรมที่มีศักยภาพในการต่อยอดสู่เชิงพาณิชย์
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_select?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การดำเนินการเตรียมความพร้อมให้กับผู้ที่เข้าร่วมโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_action?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line4 -->
          <div class="flex-center gap-16" >
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับมหาวิทยาลัย
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_act_uni?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line5 -->
          <div class="flex-center gap-16" >
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับภูมิภาค
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_act_region?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line6 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรมเส้นทางสู่นวัตวณิชย์ระดับประเทศ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_act_country?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line7 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดแนวทางการต่อยอดเพื่อพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_continue?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line8 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_p9_project_evaluate?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Form 9 activity 1 -->
    <div class="card-part" v-if="activity && activity === '1'">
      <div v-if="!isFinal">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_act_process ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            9. ขั้นตอนการดำเนินกิจกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_act_process?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_performance ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            9. ผลการดำเนินงาน
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_performance?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 9 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2'">
      <div v-if="!isFinal">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('nineAct2')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            9. กระบวนการดำเนินกิจกรรมและเกณฑ์การคัดเลือกผู้ประกอบการ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การประชาสัมพันธ์ กิจกรรม RSP New Release
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_rsp_ads?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การคัดเลือกของผู้ประกอบการ (ระดับมหาวิทยาลัย)
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_select_uni?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กิจกรรมการนาเสนอโมเดลธุรกิจนวัตกรรม (Pitching Business Innovation Model) และการประกวดเฟ้นหา RSP First
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_model?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_performance ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            9. ผลการดำเนินงาน
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_performance?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 9 activity 3 -->
    <div class="card-part" v-if="activity && activity === '3' && isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('nineAct3')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            9. ขั้นตอนการดำเนินงาน/กิจกรรมหลัก
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กระบวนการและเกณฑ์การคัดเลือกผู้ประกอบการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_ent_select?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="mb-1 black--text">
              การบริหารจัดการและกระบวนการดำเนินงานของหน่วยบ่มเพาะ
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบ่มเพาะผู้ประกอบการรายเดิม
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_original_ent?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบ่มเพาะผู้ประกอบการรายใหม่
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_new_ent?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ศักยภาพ ความพร้อมในการให้บริการของศูนย์บ่มเพาะและอุทยานวิทยาศาสตร์ภูมิภาค
              </div>
              <div class="indent-info d-flex flex-column gap-8">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      บุคลากร พี่เลี้ยง
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_nanny?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      ผู้เชี่ยวชาญที่ช่วยสนับสนุนความรู้ในด้านต่างๆ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_expert?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      เครือข่ายทางธุรกิจเทคโนโลยีที่เกี่ยวข้อง
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_network?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      โครงสร้างพื้นฐาน พื้นที่ให้เช่า และสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_facility?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      บริการอื่นๆที่เกี่ยวข้อง เช่น ด้านการเงิน การบริหารจัดการทรัพย์สินทางปัญญา เป็นต้น
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_service?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรม เส้นทางสู่นวัตวณิชย์ Research to Market (R2M)
              </div>
              <div class="indent-info d-flex flex-column gap-8">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การดำเนินงาน
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_operation?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_main_ads?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การต่อยอดพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_main_continue?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_evaluate?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Form 10 activity 1 -->
    <div class="card-part" v-if="activity && activity === '1' && !isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('tenAct1')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            10. ขั้นตอนการดำเนินงาน/กิจกรรมหลัก
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                วิธีหาลูกค้าที่มีศักยภาพ การเจาะกลุ่มเป้าหมาย และตัวอย่างผู้ประกอบการที่สนใจเข้าร่วมโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_finding?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กระบวนการและเกณฑ์การคัดเลือกผู้ประกอบการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_ent_select?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="mb-1 black--text">
              การบริหารจัดการและกระบวนการดำเนินงานของหน่วยบ่มเพาะ
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบ่มเพาะผู้ประกอบการรายเดิม
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_original_ent?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบ่มเพาะผู้ประกอบการรายใหม่
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_new_ent?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ศักยภาพ ความพร้อมในการให้บริการของศูนย์บ่มเพาะและอุทยานวิทยาศาสตร์ภูมิภาค
              </div>
              <div class="indent-info d-flex flex-column gap-8">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      บุคลากร พี่เลี้ยง
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_nanny?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      ผู้เชี่ยวชาญที่ช่วยสนับสนุนความรู้ในด้านต่างๆ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_expert?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      เครือข่ายทางธุรกิจเทคโนโลยีที่เกี่ยวข้อง
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_network?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      โครงสร้างพื้นฐาน พื้นที่ให้เช่า และสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_facility?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      บริการอื่นๆที่เกี่ยวข้อง เช่น ด้านการเงิน การบริหารจัดการทรัพย์สินทางปัญญา เป็นต้น
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_service?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การจัดกิจกรรม เส้นทางสู่นวัตวณิชย์ Research to Market (R2M)
              </div>
              <div class="indent-info d-flex flex-column gap-8">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การดำเนินงาน
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_operation?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การประชาสัมพันธ์หาผู้เข้าร่วมประกวด
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_main_ads?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      การต่อยอดพัฒนาผู้เข้าร่วมประกวดเมื่อการแข่งขันแล้วเสร็จ
                    </div>
                    <div class="pl-10" v-html="partTwoForm.s2_main_continue?.replace(/\n/g, '<br>')"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การติดตามและประเมินผลของโครงการ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_project_evaluate?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <!-- Form 10 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2'">
      <div v-if="!isFinal">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_evaluate ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            10. การติดตามและประเมินผล
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_evaluate?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('tenAct2')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            10. ผลการจัดกิจกรรมเส้นทางสู่นวัตวณิชย์
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                กิจกรรมระดับประเทศ
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แผนการดำเนินงานในการจัดการแข่งขัน (จัดการแข่งขัน  จัดเมื่อไหร่  จัดที่ไหน ใครเป็นกรรมการ ผลการแข่งขัน)
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_action_plan?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 10 activity 3 -->
    <div class="card-part" v-if="activity && activity === '3' && isFinal">
      <div class="d-flex align-center gap-24 mb-3">
        <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoForm?.s2_performance ? true : false">
        </ValidatorIcon>

        <div class="font-type-bold black--text">
          10. ผลการดำเนินงาน
        </div>
      </div>

      <div class="indent-info d-flex flex-column gap-8">
        <!-- Form 3 #line1 -->
        <div class="d-flex gap-16">
          <div class="flex xs6 d-flex gap-16">
            <div v-html="partTwoForm.s2_performance?.replace(/\n/g, '<br>')"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 11 activity 1 -->
<!--    <div class="card-part" v-if="activity && activity === '1' && isFinal">-->
<!--      <div class="d-flex align-center gap-24 mb-3">-->
<!--        <ValidatorIcon-->
<!--            v-if="!$route.query.preview && dataReady"-->
<!--            :is-correct="partTwoForm?.s2_performance ? true : false">-->
<!--        </ValidatorIcon>-->

<!--        <div class="font-type-bold black&#45;&#45;text">-->
<!--          11. ผลการดำเนินงาน-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="indent-info d-flex flex-column gap-8">-->
<!--        &lt;!&ndash; Form 3 #line1 &ndash;&gt;-->
<!--        <div class="d-flex gap-16">-->
<!--          <div class="flex xs6 d-flex gap-16">-->
<!--            <div v-html="partTwoForm.s2_performance?.replace(/\n/g, '<br>')"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!-- Form 11 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2' && isFinal">
      <div class="d-flex align-center gap-24 mb-3">
        <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoForm?.s2_rsp_procedure ? true : false">
        </ValidatorIcon>

        <div class="font-type-bold black--text">
          11. ขั้นตอนการดำเนินกิจกรรม RSP New Release
        </div>
      </div>

      <div class="indent-info d-flex flex-column gap-8">
        <!-- Form 3 #line1 -->
        <div class="d-flex gap-16">
          <div class="flex xs6 d-flex gap-16">
            <div v-html="partTwoForm.s2_rsp_procedure?.replace(/\n/g, '<br>')"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 12 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2' && isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('twelveAct2')">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            12. กระบวนการดำเนินกิจกรรมและเกณฑ์การคัดเลือกผู้ประกอบการ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การประชาสัมพันธ์ กิจกรรม RSP New Release
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_rsp_ads?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 7 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การคัดเลือกของผู้ประกอบการ (ระดับมหาวิทยาลัย) ใช้เกณฑ์ใดคัดเลือก
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_select_uni?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="mb-1 black--text">
              กิจกรรมการประกวดเฟ้นหา RSP First ในระดับประเทศ
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  แผนการดำเนินงานในการจัดการแข่งขัน (จัดการแข่งขัน  จัดเมื่อไหร่  จัดที่ไหน ใครเป็นกรรมการ ผลการแข่งขัน)
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_competition_plan?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  แผนการจัดกิจกรรมส่งเสริมการสร้างเครือข่ายผู้ประกอบการ (จัดให้มีกิจกรรมอะไร ที่ไหน การเตรียมการของแต่ละมหาวิทยาลัยและผู้ประกอบการ ใครเข้าร่วมงานบ้าง)
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_competition_network?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 13 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2' && isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_evaluate ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            13. การติดตามและประเมินผล
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_evaluate?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 14 activity 2 -->
<!--    <div class="card-part" v-if="activity && activity === '2' && isFinal">-->
<!--      <div>-->
<!--        <div class="d-flex align-center gap-24 mb-3">-->
<!--          <ValidatorIcon-->
<!--              v-if="!$route.query.preview && dataReady"-->
<!--              :is-correct="partTwoForm?.s2_performance2 ? true : false">-->
<!--          </ValidatorIcon>-->

<!--          <div class="font-type-bold black&#45;&#45;text">-->
<!--            14. ผลการดำเนินงาน-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="indent-info d-flex flex-column gap-8">-->
<!--          &lt;!&ndash; Form 3 #line1 &ndash;&gt;-->
<!--          <div class="d-flex gap-16">-->
<!--            <div class="flex xs6 d-flex gap-16">-->
<!--              <div v-html="partTwoForm.s2_performance2?.replace(/\n/g, '<br>')"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!-- Form 14 activity 2 -->
    <div class="card-part" v-if="activity && activity === '2' && isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_benefit ? true : false">
          </ValidatorIcon>

          <div class="font-type-bold black--text">
            14. ประโยชน์ที่ได้รับจากการดำเนินงาน
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_benefit?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </divcard>
</template>

<script>
import TextField from "../../../../components/input/TextField"
import SwitchInset from ".././../../../components/input/SwitchInset"
import AutoBox from "../../../../components/input/AutoBox"
import {eventBus, formatNumber, validateEmail} from "@/plugins/global-funcs"
import { mapState } from "vuex"
import OOILineField from '../../../../components/OOILineField'
import ValidatorIcon from "../../../../components/ValidatorIcon"

export default {
  name: "CFormSummary_STI",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon
  },
  props: {
    data: {
      default: () => ({})
    },
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      formatNumber,
      partTwoForm: {},
      activity: null,
      ableToSubmit: true,
      dataReady: false
    }
  },
  computed: {
    ...mapState({
      SummaryData: state => state.CForm.SummaryData
    }),
    isFinal () {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  async created () {
    eventBus.$emit('cFormSummary')
    await new Promise((res, rej) => setTimeout(res, 100))

    this.partTwoForm = this.data;
    this.activity = this.partTwoForm.activity
    this.dataReady = true
  },
  methods: {
    allowFormAbleSubmit(isCorrect) {
      if (!isCorrect && this.dataReady) {
        this.ableToSubmit = false;
      }
      eventBus.$emit("CFormPlanAbleToSubmit", this.ableToSubmit);
    },
    partTwoValidate (section) {
      let isCorrect = true
      switch (section) {
        case 'one':
          if (
              !this.partTwoForm.s2_p1_pm_name ||
              !this.partTwoForm.s2_p1_pm_position
          ) { isCorrect = false }

          if (!this.partTwoForm.s2_p1_pm_phone) { isCorrect = false }

          if (
              !validateEmail(this.partTwoForm.s2_p1_pm_email)
          ) { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'sixAct23':

          if (!this.partTwoForm.s2_act_concept ||
              !this.partTwoForm.s2_ready ||
              !this.partTwoForm.s2_qualify ||
              !this.partTwoForm.s2_criteria ||
              !this.partTwoForm.s2_guideline)
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'sevenAct2':

          if (!this.partTwoForm.s2_ads ||
              !this.partTwoForm.s2_select ||
              !this.partTwoForm.s2_action ||
              !this.partTwoForm.s2_act_uni ||
              !this.partTwoForm.s2_act_region ||
              !this.partTwoForm.s2_act_country ||
              !this.partTwoForm.s2_continue ||
              !this.partTwoForm.s2_p8_project_evaluate
          )
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'eightAct1':

          if (!this.partTwoForm.s2_finding ||
              !this.partTwoForm.s2_ent_select ||
              !this.partTwoForm.s2_original_ent ||
              !this.partTwoForm.s2_new_ent ||
              !this.partTwoForm.s2_nanny ||
              !this.partTwoForm.s2_expert ||
              !this.partTwoForm.s2_network ||
              !this.partTwoForm.s2_facility ||
              !this.partTwoForm.s2_service ||
              !this.partTwoForm.s2_operation ||
              !this.partTwoForm.s2_main_ads ||
              !this.partTwoForm.s2_main_continue ||
              !this.partTwoForm.s2_project_evaluate
          )
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'eightAct2':

          if (!this.partTwoForm.s2_operation ||
              !this.partTwoForm.s2_main_ads ||
              !this.partTwoForm.s2_main_continue)
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'eightAct3SI':

            if (!this.partTwoForm.s2_finding ||
                !this.partTwoForm.s2_ent_select ||
                !this.partTwoForm.s2_original_ent ||
                !this.partTwoForm.s2_new_ent ||
                !this.partTwoForm.s2_nanny ||
                !this.partTwoForm.s2_expert ||
                !this.partTwoForm.s2_network ||
                !this.partTwoForm.s2_facility ||
                !this.partTwoForm.s2_service ||
                !this.partTwoForm.s2_p9_project_evaluate
            )
            { isCorrect = false }

            this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'eightAct3PF':

              if (!this.partTwoForm.s2_ads ||
                  !this.partTwoForm.s2_select ||
                  !this.partTwoForm.s2_action ||
                  !this.partTwoForm.s2_act_uni ||
                  !this.partTwoForm.s2_act_region ||
                  !this.partTwoForm.s2_act_country ||
                  !this.partTwoForm.s2_continue ||
                  !this.partTwoForm.s2_p9_project_evaluate
              )
              { isCorrect = false }

              this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'nineAct2':
          if (!this.partTwoForm.s2_rsp_ads ||
              !this.partTwoForm.s2_select_uni ||
              !this.partTwoForm.s2_model
          )
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'nineAct3':
          if (!this.partTwoForm.s2_ent_select ||
              !this.partTwoForm.s2_original_ent ||
              !this.partTwoForm.s2_new_ent ||
              !this.partTwoForm.s2_nanny ||
              !this.partTwoForm.s2_expert ||
              !this.partTwoForm.s2_network ||
              !this.partTwoForm.s2_facility ||
              !this.partTwoForm.s2_service ||
              !this.partTwoForm.s2_operation ||
              !this.partTwoForm.s2_main_ads ||
              !this.partTwoForm.s2_main_continue ||
              !this.partTwoForm.s2_evaluate
          )
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'tenAct1':
          if (!this.partTwoForm.s2_finding ||
              !this.partTwoForm.s2_ent_select ||
              !this.partTwoForm.s2_original_ent ||
              !this.partTwoForm.s2_new_ent ||
              !this.partTwoForm.s2_nanny ||
              !this.partTwoForm.s2_expert ||
              !this.partTwoForm.s2_network ||
              !this.partTwoForm.s2_facility ||
              !this.partTwoForm.s2_service ||
              !this.partTwoForm.s2_operation ||
              !this.partTwoForm.s2_main_ads ||
              !this.partTwoForm.s2_main_continue ||
              !this.partTwoForm.s2_project_evaluate
          )
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'tenAct2':
          if (!this.partTwoForm.s2_action_plan
          )
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'twelveAct2':
          if (!this.partTwoForm.s2_rsp_ads ||
              !this.partTwoForm.s2_select_uni ||
              !this.partTwoForm.s2_competition_plan ||
              !this.partTwoForm.s2_competition_network
          )
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
  }
}
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #FFFFFF;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #FAFAFA;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #FFFFFF;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}


.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr));
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: 'Tahoma', sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
</style>